module.exports = __webpack_public_path__ + "media/images/cardboard-img-03-45f758e05b9016e0ed0e60e688349661.jpg";